<template>
  <div class="canvas">
    <div class="canvas__img-container">
      <transition v-if="currentPage" name="animation-fade">
          <img
              class="canvas__img canvas__img--start"
              v-if="currentPage.slug === 'sizes' || currentPage.slug === 'peoples' || (currentPage.slug === 'stages' && items.length === 0)"
              :src="[$route.path.match(/gogatsu/) ? '/choice/img/common/start_gogatsu.png' : '/choice/img/common/start.png']">
        <img
          class="canvas__img"
          :class="[canvasImg === '/choice/img/common/no-img.png' ? 'is-active' : '']"
          v-else
          :src="canvasImg"
          @click.stop="imgOpen()">
      </transition>

      <transition v-if="currentPage">
        <div class="canvas__no-choice" v-if="currentPage.slug === 'sizes' || currentPage.slug === 'peoples' || (currentPage.slug === 'stages' && items.length === 0)">
          <div class="canvas__no-choice-message">
            <template v-if="currentPage.slug === 'sizes'">
                <template v-if="$route.path.match(/gogatsu/)">カテゴリーを<br>選択してください</template>
                <template v-else>サイズを選択してください</template>
            </template>
            <template v-if="currentPage.slug === 'peoples'">
                <template v-if="$route.path.match(/gogatsu/)">人形の種類を<br>選択してください</template>
                <template v-else>人数を選択してください</template>
            </template>
            <template v-if="currentPage.slug === 'stages'">飾り台を選択してください</template>
          </div>
        </div>
      </transition>
    </div>

    <div
      class="canvas__container"
      ref="container">
      <v-stage
        ref="stage"
        class="konvajs-stage"
        :config="{
          width: stage.width,
          height: stage.height,
        }">
        <v-layer ref="layer">
          <v-canvas-image
            v-for="(item, index) in items"
            :key="item.id + '_' + index"
            :data="item"
            @canvas="canvas($event)"
            @updated="updated()"
            @beforeDestroy="beforeDestroy()"/>
        </v-layer>
      </v-stage>
    </div>
  </div>
</template>



<script>
import Vue from 'vue';
import VueKonva from 'vue-konva'
import { mapState } from 'vuex'
Vue.use(VueKonva)

export default {
  components: {
    'v-canvas-image': require('@/components/canvas-image.vue').default,
  },
  props: [
    'maxHeight'
  ],
  computed: {
    ...mapState({
      currentPage: state => state.step.current,
      canvasImg: state => state.canvas.img,
      items(state) {
        let items = state.canvas.items
        let images = []

        for (let key in items) {
          for (let i = 0; i < items[key].preview_image.length; i++) {
            for (let j = 0; j < items[key].position.length; j++) {
              if (items[key].preview_image[i].id === items[key].position[j].preview_image_id) {
                let image = {
                  id: items[key].preview_image[i].id,
                  parentId: items[key].id,
                  src: items[key].preview_image[i].src,
                  slug: items[key].page.slug,
                  x: items[key].position[j].x,
                  y: items[key].position[j].y,
                  scale: items[key].position[j].scale,
                  zindex: items[key].position[j].zindex,
                  soldout: items[key].soldout,
                }
                images.push(image)
              }
            }
          }
        }

        images.sort(function(a, b){
          if (a.zindex < b.zindex) return -1
          if (a.zindex > b.zindex) return 1
          return 0
        })

        return images
      },
    }),
  },
  data() {
    return {
      stage: {
        width: 0,
        height: 0,
      },
    }
  },
  methods: {
    imgOpen() {
      if (this.canvasImg === '/choice/img/common/no-img.png') return
      this.$confirm('<img class="el-message-box__img" src="' + this.canvasImg + '" alt="">', {
        showConfirmButton: false,
        showCancelButton: true,
        dangerouslyUseHTMLString: true,
        customClass: 'item-modal canvas__modal',
        callback: (action) => {}
      })
    },
    canvas(event) {
      this.stage.width = event.width
      this.stage.height = event.height

      this.$nextTick(() => {
        this.imageOutput()
      })
    },
    updated() {
      this.imageOutput()
    },
    beforeDestroy() {
      this.imageOutput()
    },
    imageOutput() {
      this.$nextTick(() => {
        this.$store.commit('canvas/imgSet', this.$refs.stage.getStage().toDataURL())
      })
    },
  }
}
</script>



<style lang="scss">
.canvas {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  &__img-container {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 100%;
    height: 160px;
    @include breakpoints-min(md) {
      height: 256px;
    }
  }
  &__img {
    cursor: zoom-in;
    display: block;
    transition: $transition;
    width: auto;
    max-width: 100%;
    max-height: 100%;
    &:hover {
      transform: scale(1.025);
    }
    @include breakpoints-min(lg) {
      width: 100%;
      max-height: none;
    }
    &.is-active {
      cursor: default;
    }
    &--start {
      cursor: default;
      opacity: 0.7;
      &:hover {
        transform: scale(1);
      }
    }
  }
  &__no-choice {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 1;
    transform: translate(-50%, -50%);
    border-radius: 12px;
    background-color: rgba(#fff, 0.95);
  }
  &__no-choice-message {
    font-family: $sans-serif;
    font-size: 14px;
    text-align: center;
    line-height: 2;
    letter-spacing: 0.2em;
    width: 256px;
    padding: 24px;
  }
  &__no-choice-img {
    max-width: 100%;
    max-height: 100%;
  }

  &__container {
    position: absolute;
    top: 0;
    right: 0;
    visibility: hidden;
  }
  .konvajs-stage {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  &__modal {
    .el-message-box {
      &__img {
        width: calc(100% + 32px) !important;
        margin-left: -16px;
        @include breakpoints-min(sm) {
          width: 100% !important;
          margin-left: 0;
        }
      }
    }
  }
}
</style>
